import Vue from 'vue';
import Router from 'vue-router';

// Errors
import Page403 from '@/views/errors/Page403.vue';
import Page404 from '@/views/errors/Page404.vue';
import Page500 from '@/views/errors/Page500.vue';

// Layouts
import EmptyLayout from '@/views/layouts/EmptyLayout.vue';
import AuthLayout from '@/views/layouts/AuthLayout.vue';
import DefaultLayout from '@/views/layouts/DefaultLayout.vue';

// Auth
import Login from '@/views/modules/core/auth/Login.vue';
import Registration from '@/views/modules/core/auth/Registration.vue';
import ForgotPassword from '@/views/modules/core/auth/ForgotPassword.vue';
import ResetPassword from '@/views/modules/core/auth/ResetPassword.vue';

// Routes
import CoreRoutes from '@/views/modules/core/routes';
import CmsRoutes from '@/views/modules/cms/routes';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            // Strony błędów
            path: '/error',
            redirect: '/error/404',
            component: EmptyLayout,
            children: [
                {
                    path: '403',
                    name: 'error-403',
                    component: Page403
                },
                {
                    path: '404',
                    name: 'error-404',
                    component: Page404
                },
                {
                    path: '500',
                    name: 'error-500',
                    component: Page500
                }
            ]
        },
        {
            path: '/auth',
            redirect: '/error/404',
            component: AuthLayout,
            children: [
                {
                    path: 'login',
                    name: 'login',
                    meta: { auth: false },
                    component: Login
                },
                {
                    path: 'forgot-password',
                    name: 'forgot-password',
                    meta: { auth: false },
                    component: ForgotPassword
                },
                {
                    path: 'registration',
                    name: 'registration',
                    meta: { auth: false },
                    component: Registration
                },
                {
                    path: 'reset-password/:token',
                    name: 'reset-password',
                    meta: { auth: false },
                    component: ResetPassword
                }
            ]
        },
        {
            path: '/',
            redirect: '/dashboard',
            component: DefaultLayout,
            children: [
                ...CoreRoutes,
                ...CmsRoutes
            ]
        },
        {
            // 404 Not found handler
            path: '*',
            redirect: '/error/404'
        }
    ]
});

Vue.router = router;

export default router;
